import React from 'react';
import ArrowDown from '../../asset/ArrowDown'
import frontImage from '../../img/aboutme/bg_mountain.jpg';

const firstStyle = {
  backgroundImage: `url(${frontImage})`,
};

const HeroFirst = ({tagline}) => (
  <aside className="hero bg-photo overlay" id="firstpage" style={firstStyle}>
     <div className="hero__inner">
       <h1 className="shout extra-margin-bottom">{tagline}</h1>
     </div>
     <div className="arrowAnimation">
        <ArrowDown/>
     </div>
  </aside>
);

export default HeroFirst;



// WEBPACK FOOTER //
// ./src/layout/hero/HeroFirstItem.js